<template>
  <span>
                    <span v-if="titleData.PrettyURL"  @click="panelTitleClicked">
                      {{titleData.PrettyURL}}
                    </span>
                    <span v-else>
                        <span
                            :data-role="titleData.LeftRole"
                            style="cursor: pointer;"
                            ref="threadRoleIcon"
                            @click="threadRoleClicked($event)"
                            v-show="!simpleMode"
                            class="far fa-share-alt ">
                        </span>&nbsp;
                        <span
                            :title="fullThreadTitle"
                            :data-role="titleData.LeftRole"
                            style="cursor: pointer;"
                            :style="{'font-size':oxygenUtil.config.fontSize}"
                            @click="panelTitleClicked"


                            >{{threadTitle}}
                        </span>
                        <span v-if="showSubject">
                        &nbsp;/
                        <span
                            :data-role="titleData.RightRole"
                            style="cursor: pointer;"
                            ref="subjectRoleIcon"
                            v-show="!simpleMode"
                            @click="subjectRoleClicked($event)"
                            class="far fa-share-alt">
                        </span>&nbsp;
                        <span
                            :title="fullSubjectTitle"
                            :data-role="titleData.RightRole"
                            style="cursor: pointer;"
                            @click="panelTitleClicked"
                            :style="{'font-size':oxygenUtil.config.fontSize}"

                           >{{subjectTitle}}
                        </span>
                        </span>
                        <span :style="{'font-size':oxygenUtil.config.fontSize}" v-if="titleData.extendedTitle">
                        &nbsp;/&nbsp;{{titleData.extendedTitle}}
                        </span>
                    </span>

                </span>

</template>

<script setup>

  import { ref, reactive, watch, computed } from 'vue';
  import * as oxygenUtil from './../OxygenUtil/oxygenutil.js';
  //import { Tooltip } from 'uiv';
  //import { VTooltip } from 'floating-vue';
  //window.mainApp.directive('tooltip', VTooltip);

  let props = defineProps({
    titleData: Object,
    subjectRoleModal: Object,
    threadRoleModal: Object,
    threadRoleModalStyles: Object,
    subjectRoleModalStyles: Object,
    subjectRoles: Array,
    threadRoles: Array,
    callback: Function,
    simpleMode: {
      type: Boolean,
      default: false
    },
    meetingMode: {
      type: Boolean,
      default: false
    }
  });
  let emit = defineEmits(['panel-title-clicked']);

  let threadRoleIcon = ref(null), subjectRoleIcon = ref(null);

  const showSubject = computed(()=>{
    //console.log('showSubject', props.titleData.RightDN, props.titleData.LeftDN, ' - ',props.titleData.RightRole, props.titleData.LeftRole);
    //console.log('showSubject:', ((props.titleData.RightDN != props.titleData.LeftDN) || (props.titleData.RightRole != props.titleData.LeftRole)))
    return ((props.titleData.RightDN != props.titleData.LeftDN) || (props.titleData.RightRole != props.titleData.LeftRole));
  });

  const threadTitle = computed(()=>{
    if(!props.meetingMode) {
      return oxygenUtil.formatDN(props.titleData.LeftDN);
    }
    else {
      return props.titleData.MeetingRootDN ?
          oxygenUtil.formatDN(props.titleData.MeetingRootDN) :
          oxygenUtil.formatDN(props.titleData.LeftDN);
    }
  });


  const subjectTitle = computed(()=>{
    if(!props.meetingMode) {
      return oxygenUtil.formatDN(props.titleData.RightDN);
    }
    else {
      return props.titleData.MeetingParentDN ?
          oxygenUtil.formatDN(props.titleData.MeetingParentDN) :
          oxygenUtil.formatDN(props.titleData.RightDN);
    }
  });

  const fullThreadTitle = computed(()=>{
    if(!props.meetingMode) {
      return props.titleData.LeftDN;
    }
    else {
      return props.titleData.MeetingRootDN || props.titleData.LeftDN;
    }
  });


  const fullSubjectTitle = computed(()=>{
    if(!props.meetingMode) {
      return props.titleData.RightDN;
    }
    else {
      return props.titleData.MeetingRootDN || props.titleData.RightDN;
    }
  });

  function threadRoleClicked() {
    addThreadRoles();
    /*
    let threadRoleIconRect = threadRoleIcon.value.getBoundingClientRect();
    props.threadRoleModalStyles['position'] = 'absolute';
    props.threadRoleModalStyles['top'] = `${threadRoleIconRect.top + threadRoleIconRect.height}px`;
    props.threadRoleModalStyles['left'] = `${threadRoleIconRect.left}px`;

    props.threadRoleModal.showModal();
     */
    props.threadRoleModal.showModalAlignedToElement(threadRoleIcon.value, 'left', 'bottom');
  }


  function subjectRoleClicked() {
    addSubjectRoles();
    /*
    let subjectRoleIconRect = subjectRoleIcon.value.getBoundingClientRect();
    console.log('rect:', subjectRoleIconRect);
    props.subjectRoleModalStyles['position'] = 'absolute';
    props.subjectRoleModalStyles['top'] = `${subjectRoleIconRect.top + subjectRoleIconRect.height}px`;
    props.subjectRoleModalStyles['left'] = `${subjectRoleIconRect.left}px`;

    props.subjectRoleModal.showModal();
     */
    props.subjectRoleModal.showModalAlignedToElement(subjectRoleIcon.value, 'left', 'bottom');
  }


  function panelTitleClicked() {
    props.callback(props.titleData);
  }

/*
  watch(
    props.titleData,
      ()=>{
        addThreadRoles();
        addSubjectRoles();
      },
      { initial: true }
  );
*/

  function addThreadRoles() {
    console.log('addThreadRoles', 'threadRoles:',  props.threadRoles);
    props.threadRoles.length = 0;
    props.threadRoles.push({
      title: capitalizeFirstLetter(props.titleData.LeftRole),
      disabledCheckbox: true,
      selected: true,
      callback: ()=>{}
    });
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }


  function addSubjectRoles() {
    console.log('addSubjectRoles', 'subjectRoles:',  props.subjectRoles);
    props.subjectRoles.length = 0;
    props.subjectRoles.push({
      title: capitalizeFirstLetter(props.titleData.RightRole),
      disabledCheckbox: true,
      selected: true,
      callback: ()=>{}
    });
  }

</script>
<style>

</style>
